import { observer } from 'mobx-react';

import { useFlag } from '../../../services/launchDarkly';
import { ChooseCountryComponentRedesign } from '../redesign-components/ChooseCountryRedesign/ChooseCountryComponentRedesign';

import { ChooseCountryComponent } from './ChooseCountryComponent';
import type { ChooseCountryProps } from './types';

const ChooseCountry = observer(function ChooseCountry(props: ChooseCountryProps) {
  const isSignUpUiRedesignEnabled = useFlag<boolean>('ui_redesign_registration_flow', false);
  if (props.wizardFlowParams?.isRedesignSteps === false || !isSignUpUiRedesignEnabled) {
    return <ChooseCountryComponent {...props} />;
  }
  return <ChooseCountryComponentRedesign {...props} />;
});

export default ChooseCountry;
